import { render, staticRenderFns } from "./assessFormTable.vue?vue&type=template&id=77f40fec&scoped=true&"
import script from "./assessFormTable.vue?vue&type=script&lang=js&"
export * from "./assessFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f40fec",
  null
  
)

export default component.exports